import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './ContentContainer.module.css';

const ContentContainer = ({ children, fullBleed, wide, noPad, className = '', ...rest }) => {
  return (
    <div
      className={[
        wide ? styles.containerWide : '',
        noPad ? styles.noPad : '',
        fullBleed ? styles.containerFull : styles.container,
        'group',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
};

ContentContainer.defaultProps = {
  fullBleed: false,
  wide: false,
};

ContentContainer.propTypes = {
  children: PropTypes.any,
  fullBleed: PropTypes.bool,
  wide: PropTypes.bool,
  className: PropTypes.string,
};

export default ContentContainer;
